export default {
  install(Vue, options) {
    Vue.prototype.$format = {};

    Vue.prototype.$format.JsonAddressToString = (json) => {
      let result = '';
      if (typeof json !== 'undefined') {
        let address = JSON.parse(json);
        let displayAttributes = [
          'street_address',
          'locality',
          'region',
          'country',
          'postal_code'
        ];
        displayAttributes.forEach((attr, attrIndex) => {
          if (typeof address[attr] !== 'undefined') {
            result += address[attr] + (attrIndex === (displayAttributes.length - 1)? '' : ' ');
          }
        });
      }
      return result;
    };

  }
};
